//resources
import Vue from 'vue';
import App from './App.vue';
import VueResource from 'vue-resource';
import VueGtm from 'vue-gtm'
import VueRouter from 'vue-router';
import VueLazyload from 'vue-lazyload';
import VueMoment from 'vue-moment';
import VueHead from 'vue-head';
import objectFitImages from 'object-fit-images';
import VModal from 'vue-js-modal'
import { Tab, Tabs } from 'vue-tmn-tabs';
//import VueCollapse from 'vue2-collapse'

//layout
import Header from './layout/header-component.vue';
import Footer from './layout/footer-component.vue';
//landings
import Home from './landings/Home.vue';
import Works from './landings/Works.vue';
import CaseStudy from './landings/CaseStudy.vue';
import Solutions from './landings/Solutions.vue';
import SolutionDetail from './landings/SolutionDetail.vue';
import Words from './landings/Words.vue';
import Article from './landings/Article.vue';
import Expertise from './landings/Expertise.vue';
// import Markets from './landings/Markets.vue';
// import MarketsDetail from './landings/MarketDetail.vue';
import Careers from './landings/Careers.vue';
import JobsPage from './landings/JobsPage.vue';
import Agency from './landings/Agency.vue';
import Contact from './landings/Contact.vue';
import Terms from './landings/Terms.vue';
import Privacy from './landings/Privacy.vue';
import NotFound from './landings/NotFound.vue';
import InternalError from './landings/InternalError.vue';
import CX2 from './landings/CX2.vue';
import BigWebtoolBox from './landings/BigWebtoolBox.vue';
import DoItWithMe from './landings/DoItWithMe.vue';
import Inclusion from './landings/Inclusion.vue';
import InclusionSections from './landings/InclusionSections.vue';
import InclusionCaseStudies from './landings/InclusionCaseStudies.vue';
import InclusionCaseStudiesDetail from './landings/InclusionCaseStudiesDetail.vue';
// import IDEA from './landings/IDEA.vue';

import HealthCare from './landings/HealthCare.vue';
import FirstPartyData from './landings/FirstPartyData.vue';

import Lottery from './landings/Lottery.vue';
import Superbowl from './landings/Superbowl.vue';
import Dexcom from './landings/Dexcom.vue';
import AdForum from './landings/ADforum.vue';
import Test from './landings/Test.vue';
import Pages from './landings/Pages.vue';
import CodeOfConduct from './landings/CodeOfConduct.vue';

//Icons
import 'vue-awesome/icons/' ;
import Icon from 'vue-awesome/components/Icon.vue'
//Directives
import inViewportDirective from 'vue-in-viewport-directive';
import { directive as onClickOutside } from 'vue-on-click-outside' ;
//Extras
import VueSimpleBreakpoints from 'vue-simple-breakpoints';
import VueScrollTo from 'vue-scrollto';
import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';

//use resources
var loadingIcon = require('./assets/img/tail-spin.svg');
Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(VueHead);
Vue.use(VModal)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: loadingIcon,
  attempt: 1
});

//Register components
Vue.component('header-component',Header);
Vue.component('footer-component',Footer);

//Register icons
Vue.component('icon',Icon);

//Register directives
Vue.directive('in-viewport', inViewportDirective);
Vue.directive('on-click-outside', onClickOutside);

// extras
Vue.use(VueSimpleBreakpoints, { mobile: 767, tablet: 1024, small_desktop: 1024, large_desktop: 1200 });
Vue.use(VueScrollTo);
Vue.use(VueMoment);
Vue.use(VeeValidate, {
  events: 'input' // validate on input only
});

Vue.use(VueGtm, {
  debug: true, // Whether or not display console logs debugs (optional)
  vueRouter: router
})

Vue.component('tab', Tab);
Vue.component('tabs', Tabs);
//Vue.use(VueCollapse)

const routes = [
	{ path: '/', component: Home },
	{ path: '/work', component: Works },
	{ path: '/work/:id', component: CaseStudy},
	{ path: '/solutions', component: Solutions},
	{ path: '/solutions/expertise/:id', component: Expertise},
  { path: '/solutions/:id', component: SolutionDetail},
	{ path: '/words', component: Words},
	{ path: '/words/:id', component: Article},
	// { path: '/markets', component: Markets},
	// { path: '/markets/:id', component: MarketsDetail},
	{ path: '/careers', component: Careers},
  { path: '/jobs', component: JobsPage},
	{ path: '/agency', component: Agency},
  { path: '/inclusion', component: Inclusion},
  { path: '/inclusion/case-studies', component: InclusionCaseStudies},
  { path: '/inclusion/:id', component: InclusionSections},
  { path: '/inclusion/case-studies/:id', component: InclusionCaseStudiesDetail},
	{ path: '/contact', component: Contact},
	{ path: '/terms', component: Terms},
  { path: '/code-of-conduct', component: CodeOfConduct},
	{ path: '/privacy', component: Privacy},
	{ path: '/404', component: NotFound },
	{ path: '/500', component: InternalError },
	{ path: '*', redirect: '/404' },
  { path: '/myjourney', component: CX2},
  { path: '/bigwebtoolbox', component: BigWebtoolBox},
  { path: '/doitwithme', component: DoItWithMe},
  { path: '/healthcare', component: HealthCare},
  { path: '/firstpartydata', component: FirstPartyData},
  // { path: '/agency/idea', component: IDEA},
  { path: '/lotterysolutions', component: Lottery},
  { path: '/Dexcom_Rant', component: Superbowl},
  { path: '/Dexcom-magic-moments', component: Dexcom},

  
  { path: '/adforum_2022', component: AdForum},
  { path: '/test', component: Test},
  { path: '/pages/:id', component: Pages},
  { path: '/valottery', beforeEnter() {location.href = ' https://demoapps.marcusthomasllc.com/virginialottery/index.html'}},
  { path: '/agency/diversity', beforeEnter() {location.href = '/inclusion'}},

];



const router = new VueRouter({
	routes,
	mode: 'history' // prevent URL's to use # in them

});

var vm = new Vue({
  el: '#app',
  router,
  render: h => h(App)
})

// const ignoredMessage = "The .native modifier for v-on is only valid on components but it was used on <a>.";
// Vue.config.warnHandler = (message, vm, componentTrace) => {
//   if (message !== ignoredMessage) {
//       console.error(message + componentTrace);
//   }
// };


// force scroll top
window.onbeforeunload = function () {
  window.scrollTo(0, 0);
}





// WEBPACK FOOTER //
// ./src/main.js